/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import TwoFactorDisabledIcon from "../../../../../assets/customIcons/security/TwoFactorDisabledIcon";
import TwoFactorEnabledIcon from "../../../../../assets/customIcons/security/TwoFactorEnabledIcon";
import { ENABLE_AUTHENTICATION_STEPS } from "../../../types";
import { useStyles } from "../styles";

interface MainIconProps {
  step: ENABLE_AUTHENTICATION_STEPS;
}

const MainIcon = ({ step }: MainIconProps) => {
  const isSelectMethodStep = step === ENABLE_AUTHENTICATION_STEPS.SelectMethod;

  const { mainIconContainer } = useStyles({ isSelectMethodStep });

  const isSuccessMessageStep =
    step === ENABLE_AUTHENTICATION_STEPS.SuccessMessage;

  return (
    <div css={css(mainIconContainer)} data-testid="two-fa-main-icon">
      {isSuccessMessageStep ? (
        <TwoFactorEnabledIcon />
      ) : (
        <TwoFactorDisabledIcon />
      )}
    </div>
  );
};

export { MainIcon };
